import React from 'react';
import { Phone, Wrench, Repeat } from 'lucide-react';

const services = [
  {
    icon: Phone,
    title: 'Outbound as a Service',
    tag: 'We run it. You close deals.',
    description:
      'LinkedIn outreach, cold calling, cold email — all handled by our team. Meetings show up on your calendar. You just close them.',
  },
  {
    icon: Wrench,
    title: 'Outbound Infrastructure',
    tag: 'We build it. You run it.',
    description:
      'We create your scripts, templates, target lists, and coach your team. Everything you need to run outbound yourself — built by people who actually do it.',
  },
  {
    icon: Repeat,
    title: 'NIMBLE Pipeline System',
    tag: 'Stop buying leads. Stop cold calling. Stop networking aimlessly.',
    description:
      'A referral generation system that keeps your calendar full of warm introductions. No ads, no cold outreach, no networking events. Just a system that works.',
  },
];

const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="section" style={{ backgroundColor: 'var(--bg-secondary)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-lg mb-4">What We Do</h2>
          <p className="text-base md:text-lg" style={{ color: 'var(--text-secondary)' }}>
            Three ways to build your pipeline. Pick what fits.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div key={service.title} className="card" data-testid={`service-card-${service.title.toLowerCase().replace(/\s+/g, '-')}`}>
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center mb-6"
                style={{ backgroundColor: 'var(--bg-accent)' }}
              >
                <service.icon className="w-6 h-6" style={{ color: 'var(--brand-primary)' }} />
              </div>
              <h3 className="heading-md mb-2">{service.title}</h3>
              <p className="text-sm font-semibold mb-4" style={{ color: 'var(--brand-primary)' }}>
                {service.tag}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
